import Pagination from "./components/Pagination";

export default Pagination;



// WEBPACK FOOTER //
// ./src/lib/index.js